import { Amplify as g } from "aws-amplify";
import { put as l, post as y, patch as E, head as S, get as q, del as _ } from "aws-amplify/api";
import { Hub as k } from "aws-amplify/utils";
import { fetchAuthSession as h, AuthError as w } from "aws-amplify/auth";
import { cognitoUserPoolsTokenProvider as b } from "aws-amplify/auth/cognito";
import u from "lodash/get";
import i from "lodash/has";
import T from "lodash/merge";
import A from "lodash/cloneDeepWith";
import R from "lodash/isEmpty";
import P from "lodash/omit";
import { parseJSON as I, isDate as m, transpose as D, formatISO as O } from "date-fns";
import { tz as p, TZDate as $ } from "@date-fns/tz";
import { u as N } from "../stores/auth.al0TMRKc.js";
import { p as z, e as C, N as x } from "./errorhandler.CNhMajq3.js";
const F = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/i, U = /^\d{4}/, B = 120, K = {
  del: _,
  get: q,
  head: S,
  patch: E,
  post: y,
  put: l
};
class st {
  /**
   * Static initialisation of Amplify and cognito token storage
   * @param {Object} awsExports
   * @param {KeyValueStorageInterface} storage
   */
  static init(t, e) {
    g.configure(t), b.setKeyValueStorage(e);
  }
  constructor() {
    this.catchErrorSkip = 0;
  }
  /**
   * Disable error handling temporarily.
   * chain this in your call, e.g. api.doNotCatchIfError().get('...')
   */
  doNotCatchIfError() {
    return this.catchErrorSkip += 1, this;
  }
  catchErrors() {
    return this.catchErrorSkip = 0, this;
  }
  static getTimezone() {
    return N().user.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /**
   * Transforms an API response
   * @param {string} response
   * @returns {Object|string}
   */
  static transformResponse(t) {
    if (typeof t != "string")
      throw new Error(
        `string value must be passed to transformResponse, got ${typeof t}`
      );
    if (t.length === 0)
      return t;
    let e;
    return JSON.parse(t, (o, r) => {
      if (typeof r == "string" && r.length >= 10 && U.test(r)) {
        if (!F.test(r))
          return r;
        const n = I(r);
        if (m(n))
          return e === void 0 && (e = p(this.getTimezone())), D(n, e);
      }
      return r;
    });
  }
  /**
   * Transforms an API request
   * @param {object} request
   * @returns {object}
   */
  static transformRequest(t) {
    let e;
    return A(t, (r) => {
      if (m(r))
        return r instanceof $ ? (e === void 0 && (e = p("UTC")), O(r, { in: e })) : r.toISOString();
    });
  }
  /**
   * Wrapper around amplify's fetch wrapper(!)
   * Does some wrangling to be more consistent with axios (which amplify used prior to fetch)
   *
   * @param {string} verb HTTP verb
   * @param {string} apiName Amplify api name
   * @param {string} path API url
   * @param {object} init Amplify api init request options
   *    that are merged with authorization defaults
   * @returns {Promise}
   */
  async request(t, e, o, r = {}) {
    let n = !0;
    try {
      this.catchErrorSkip !== 0 && (n = !1, this.catchErrorSkip -= 1);
      const a = await this.constructor.getDefaultInit(
        u(r, "noAuth", !1)
      ), s = T({}, a, r);
      i(s, "noAuth") && delete s.noAuth, i(s, "body") && (s.body = this.constructor.transformRequest(s.body)), i(s, "queryStringParameters") && (s.queryParams = this.constructor.transformRequest(
        s.queryStringParameters
      ), delete s.queryStringParameters);
      const c = await K[t]({
        apiName: e,
        path: o,
        options: s
      }).response, d = c.statusCode === 204 ? "" : await c.body.text();
      let f = this.constructor.transformResponse(d);
      return f = this.constructor.handleResponseMessages(f), f;
    } catch (a) {
      if (!n) {
        const s = z(a);
        throw new Error(s.message, { cause: a });
      }
      return C(a), !1;
    }
  }
  async get(t, e, o = {}) {
    return this.request("get", t, e, o);
  }
  /**
   * wrapper around get(), automatically paginates to retrieve all results
   *
   * @param {string} apiName Amplify api name
   * @param {string} path API url
   * @param {object} init Amplify api init request options
   *    that are merged with authorization defaults
   * @returns {Promise}
   */
  async getAllPages(t, e, o = {}) {
    let r = await this.request("get", t, e, o);
    if (r === !1)
      return !1;
    const n = [];
    if (!i(r, "_embedded"))
      throw new Error("No _embedded found in API response");
    const a = Object.keys(u(r, "_embedded"))[0];
    if (i(r, `_embedded.${a}`) && !R(u(r, `_embedded.${a}`))) {
      n.push(...u(r, `_embedded.${a}`));
      const s = structuredClone(o);
      for (i(s, "queryStringParameters") || (s.queryStringParameters = {
        page: 1
      }), i(s, "queryStringParameters.page") || (s.queryStringParameters.page = 1); r.total > n.length && r.count !== 0; ) {
        if (s.queryStringParameters.page += 1, r = await this.request("get", t, e, s), !i(r, `_embedded.${a}`))
          throw new Error("No _embedded found in subsequent API response");
        n.push(...u(r, `_embedded.${a}`));
      }
    }
    return {
      _links: r._links,
      count: n.length,
      total: n.length,
      _embedded: {
        [a]: n
      }
    };
  }
  async del(t, e, o = {}) {
    return this.request("del", t, e, o);
  }
  async head(t, e, o = {}) {
    return this.request("head", t, e, o);
  }
  async post(t, e, o = {}) {
    return this.request("post", t, e, o);
  }
  async put(t, e, o = {}) {
    return this.request("put", t, e, o);
  }
  async patch(t, e, o = {}) {
    return this.request("patch", t, e, o);
  }
  /**
   * Setup default request config
   * @param {boolean} noAuth Don't add Authentication header to the request
   * @returns {Promise}
   */
  static async getDefaultInit(t = !1) {
    return t === !0 ? {} : {
      headers: {
        Authorization: `Bearer ${await this.fetchAuthToken()}`
      }
    };
  }
  /**
   * Fetch the current auth token from aws amplify or an exception if the user
   * isn't logged in (and standard ones if there are network / service errors)
   * @returns {Promise<String>} the auth (jwt) token
   * @throws {NoCurrentUserError} if no session
   */
  static async fetchAuthToken() {
    var e, o, r, n, a;
    let t;
    try {
      let s = await h();
      const d = ((((r = (o = (e = s == null ? void 0 : s.tokens) == null ? void 0 : e.accessToken) == null ? void 0 : o.payload) == null ? void 0 : r.exp) ?? 0) - B) * 1e3;
      Date.now() > d && (s = await h({ forceRefresh: !0 })), t = (a = (n = s == null ? void 0 : s.tokens) == null ? void 0 : n.idToken) == null ? void 0 : a.toString();
    } catch (s) {
      s instanceof w ? console.debug(s) : console.warn(s);
    }
    if (t == null)
      throw new x();
    return t;
  }
  /**
   * Handle api responses that contain more detailed messages
   * Often used for creating more complex toast-messages
   * @param {object} response
   * @returns {object}
   */
  static handleResponseMessages(t) {
    return i(t, "_messages") ? (t._messages.forEach((e) => {
      k.dispatch("toast", {
        event: u(e, "type", "info"),
        data: e
      });
    }), P(t, "_messages")) : t;
  }
}
export {
  st as A
};
